import { render, staticRenderFns } from "./LevelVariableSalaryModal.vue?vue&type=template&id=508a483e&scoped=true&"
import script from "./LevelVariableSalaryModal.vue?vue&type=script&lang=ts&"
export * from "./LevelVariableSalaryModal.vue?vue&type=script&lang=ts&"
import style0 from "./LevelVariableSalaryModal.vue?vue&type=style&index=0&id=508a483e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a483e",
  null
  
)

export default component.exports